import React from 'react';
import Background from '../components/Background';
import Team from '../components/Team';

const TeamPage = () => {
  return (
    <>
      <Background />
      <div className="page">
        <Team />
      </div>
    </>
  );
};

export default TeamPage;
